import React, { useContext } from 'react'
import PropTypes from 'prop-types'
import Context from '../context/Context'
import { PayoutMethods } from '../helpers/Constants'

const InfoText = ({ sitePayoutMethodId }) => {
  switch (parseInt(sitePayoutMethodId)) {
  case PayoutMethods.ACCOUNT:
    return 'Ditt tillgodo kommer utbetalas till tidigare angivet kontonummer.'
  case PayoutMethods.PAPER:
    return 'Beloppet kommer att utbetalas till dig via separat avi.'
  default:
    return 'Vänligen kontakta kundtjänst för utbetalning av tillgodobelopp.'
  }
}

const PayoutInfo = () => {
  const context = useContext(Context)

  return (
    <div className="row mt-4">
      <div className="col-10 offset-1 text-center">
        <span className="paragraph-regular-14">
          {<InfoText sitePayoutMethodId={context.invoice.site_payout_method_id} />}
        </span>
      </div>
    </div>
  )
}

InfoText.propTypes = {
  sitePayoutMethodId: PropTypes.string
}

export default PayoutInfo
